import React from'react';import{i18n}from'@shopgate/engage/core';/**
* The Coupon Code component.
* @param {Object} props The component props.
* @returns {JSX}
*/export var CartItemCouponCode=function CartItemCouponCode(_ref){var value=_ref.value;return React.createElement("div",null,"".concat(i18n.text('cart.coupon_code'),": ").concat(value));};